/**
 * Get Current Page URL parts
 * @param  {String} part  The URL part that you want to retrive
 * @return {String}       The wanted portion of the current page URL
 * 
 *  Available parts options and return value examples:
 *  hash: "#anchorID"
 *  search: "?query=parameters"
 *  host: "deadbydaylight.com"
 *  domain: ".deadbydaylight.com"
 *  href: "https://deadbydaylight.com/"
 *  origin: "https://deadbydaylight.com"
 *  pathname: "/game/chapters/"
 */

export const getPageURL = (part) => {
  const isBrowser = typeof window !== 'undefined'
  let currentDomain = ''

  if (isBrowser && window.location.hostname !== 'localhost') {
    currentDomain = `${window.location[part]}`
    if (part === 'domain') {
      currentDomain = `.${window.location.host}`
    }
  } else {
    currentDomain = 'localhost'
  }

  return currentDomain
}
